// Community Inbox — collision soft-lock (claim) TTL logic. Pure; shared by the
// server action service (claim/release + send-into-live-claim warning) and the
// client ("X is replying…" indicator).
//
// A claim is a SOFT lock: `claimedByUid` + `claimedAt` set when an agent opens
// the reply composer, cleared on send / navigate-away. A crashed tab never
// releases, so a claim older than the TTL is treated as free — no cleanup job
// needed.

export const INBOX_CLAIM_TTL_SECONDS = 120;

/**
 * Is a claim still live? False for no claim, an unparseable timestamp, or a
 * claim older than the TTL. `nowMs` injected for testability.
 */
export function isClaimActive(
  claimedAt: string | null | undefined,
  nowMs: number,
  ttlSeconds: number = INBOX_CLAIM_TTL_SECONDS,
): boolean {
  if (!claimedAt) return false;
  const at = Date.parse(claimedAt);
  if (!Number.isFinite(at)) return false;
  return nowMs - at < ttlSeconds * 1000;
}

/**
 * Does `otherUid` hold a live claim that should warn `uid` before acting?
 * (Your own claim never warns.)
 */
export function isClaimedByOther(
  thread: { claimedByUid: string | null; claimedAt: string | null },
  uid: string,
  nowMs: number,
  ttlSeconds: number = INBOX_CLAIM_TTL_SECONDS,
): boolean {
  if (!thread.claimedByUid || thread.claimedByUid === uid) return false;
  return isClaimActive(thread.claimedAt, nowMs, ttlSeconds);
}
